import { Brand, Retailer } from './account'

export enum FavoriteStatus {
  Favorited = 'Favorited',
  NonFavorited = 'Non favorited',
}

export enum VisibilityType {
  Owner = 'OWNER',
  Public = 'PUBLIC',
  AllConnections = 'ALL_CONNECTIONS',
  SelectedConnections = 'SELECTED_CONNECTIONS',
  OwnerPublic = 'OWNER_PUBLIC',
  OwnerAllConnections = 'OWNER_ALL_CONNECTIONS',
}

export interface Group {
  id: string
  header: string
  orderNbr: number
}

export interface Season {
  id?: string
  code?: string
  name: string
  year: number
}

export interface Delivery {
  id: string
  startShipDate?: string
  cutoffDate?: string
  completeShipDate?: string
  minimumShippingWindow?: number
}

export type CollectionDeliveryWindow = {
  maxCompleteShipDate?: Date
  minStartShipDate?: Date
}

export interface RetailerAccount {
  retailerAccount: Retailer
}

export interface Owner {
  id: string
  email: string
}

export interface CollectionImage {
  id: string
  url: string
  urlThumbnail: string
  fileName?: string
  mimeType?: string
}

/**
 * We have three collection models.
 *
 * * Collection: The one that we use.
 * * AgGridCollection: The one that the table uses.
 * * GraphQLCollection: The one returned by the server.
 */

export interface Collection {
  archived: boolean
  brandId: string
  code?: string
  created: string
  favorite?: FavoriteStatus
  id: string
  modified: string
  name: string
  owner?: string
  retailers?: Retailer[]
  seasonId?: string
  syncToIpad: boolean
  visibility?: VisibilityType[]
  image?: CollectionImage
  delivery?: Delivery
  isCustom?: boolean
}

export interface AgGridCollection {
  archived: boolean
  collection_id: string
  collection_name: string
  created: Date
  favorite?: FavoriteStatus
  modified: Date
  owner?: string
  season_id?: string
  sync_to_ipad: boolean
  visibility?: VisibilityType // TODO Review what happens if visibility is undefined in Collection
  isCustom?: boolean
}

type TextStyle = {
  id?: string
  name: string
  typeface: string
  weight: string
  size: string
  orderNbr: number
}

type Source = {
  id: string
  name: string
}
export interface GraphQLCollection {
  archived: boolean
  brand: Brand
  code: string
  created: string
  delivery: Delivery
  description: string
  id: string
  isCustom: boolean
  madeToOrder: boolean
  modified: string
  name: string
  owner: { node: Owner }
  retailers: RetailerAccount[]
  season: Season
  syncToIpad: boolean
  visibility: VisibilityType
  groups: Group[]
  textStyles?: TextStyle[]
  source: Source
  image?: CollectionImage
}

export type CollectionBrand = Brand & {
  code?: string
}

export type Inventory = {
  positive: number
  negative: number
}
